import {Mapper} from '@s-ui/domain'

export class FromPageNameToModelDetailBreadcrumbVOMapper extends Mapper {
  constructor({config, breadcrumbValueObjectFactory}) {
    super()
    this._config = config
    this._breadcrumbValueObjectFactory = breadcrumbValueObjectFactory
    const {
      MODEL_DETAIL_PATH_PATTERN,
      MAKES_SIZES_DISTRIBUTOR_PAGE_NAME,
      MODEL_SIZES_PAGE_NAME,
      MODEL_DETAIL_INTERIOR_PAGE_NAME,
      MODEL_DETAIL_TRUNK_PAGE_NAME
    } = this._config.get('page')
    this._modelDetailPathPattern = MODEL_DETAIL_PATH_PATTERN
    this._middleSegments = {
      [MODEL_SIZES_PAGE_NAME]: {label: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_SIZES_TEXT'},
      [MAKES_SIZES_DISTRIBUTOR_PAGE_NAME]: {label: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_SIZES_TEXT'},
      [MODEL_DETAIL_INTERIOR_PAGE_NAME]: {label: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_INTERIOR_TEXT'},
      [MODEL_DETAIL_TRUNK_PAGE_NAME]: {label: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_TRUNK_TEXT'}
    }
  }

  _getMakeModelSearchSegment = () => {
    return {
      label: 'NAVIGATION_MAIN_TECHNICAL_DATA_COCHES_MAKE_MODEL_SEARCH_TEXT',
      url: this._modelDetailPathPattern
    }
  }

  _getMakeSegment = ({make, makeSlug}) => {
    if (!make) return
    return {
      label: 'BREADCRUMB_MODEL_DETAIL_MAKE_LABEL',
      params: {make},
      url: `${this._modelDetailPathPattern}${makeSlug.toLowerCase()}/`
    }
  }

  _getModelSegment = ({model}) => {
    if (!model) return
    return {
      label: model
    }
  }

  map = ({pageName, make, model, makeSlug = ''}) => {
    const middelSegment = this._middleSegments[pageName]
    const makeModelSearchSegment = this._getMakeModelSearchSegment()
    const makeSegment = this._getMakeSegment({make, makeSlug})
    const modelSegment = this._getModelSegment({model})

    return this._breadcrumbValueObjectFactory({
      breadcrumbs: [makeModelSearchSegment, middelSegment, makeSegment, modelSegment].filter(Boolean)
    })
  }
}
